<template>
  <div class="home-container">     
    <div class="home-content">
      <!-- nav is right position  -->
      <div v-if="user" class="nav">
        <div @click="navToggle">{{ user.username }}</div>        
        <div v-show="isNav">                   
          <input v-if="isRename" type="text" v-on:keyup.enter="renameDB" v-model="renameText">
          <div v-else @click="renameToggle">rename</div>  
          <div @click="showHelp">help</div>        
        </div>
      </div>    
      <!-- inner of home-content -->
      <div class="inner-width">
        <h1 class="title">Terminal RPG</h1>
        <p>Can you defeat the boss?</p>    
        <div class="auth-status">
          <a v-if="user" @click="signOut" class="blue-border">
            Log out
          </a>    
          <a v-else @click="signUpAndLogIn" class="blue-border">
            Log in
          </a>    
        </div>
        <div class="div">
          <a v-if="user" href="/boss" class="grey--btn grey-border">START</a>
          <a v-else @click="pleaseLogin" class="grey--btn grey-border">START</a>          
        </div>
        <WinnersList/>        
      </div>       
    </div>
    <Help/>
    <MyFooter/>
  </div>    
</template>

<script>
import { db } from '@/firebase'
// components
import WinnersList from "@/components/WinnersList.vue"
import Help from "@/components/Help.vue"
import MyFooter from "@/components/MyFooter.vue"

export default {
  components:{
    WinnersList,
    Help,
    MyFooter
  },
  data(){
    return{          
      isNav: false,
      isRename: false,
      renameText: "",      
    }
  },
  computed: {
    user(){
      return this.$store.state.user
    },  
  }, 
  methods:{
    signUpAndLogIn: function () {
      this.$store.dispatch('signUpAndLogIn')
    },
    signOut: function () {
      this.$store.dispatch('signOut')
    },     
    navToggle(){   
      this.isNav = (this.isNav) ? false : true
      this.isRename = false
    },
    renameToggle(){
      this.isRename = (this.isRename) ? false : true
    },
    renameDB(){
      if(this.renameText != ""){        
        db.collection('users').doc(this.user.uid).update({
          username: this.renameText
        })
        this.renameToggle() 
      } else {
        alert("Pealse fill in")
      }                 
    },
    showHelp() {
      alert("Scroll down by yourself")
    },    
    pleaseLogin(){
      alert("Please Sign up...")
    }, 
  }
}
</script>

<style lang="scss">
.home-container{  
  .home-content{    
    min-height: 100vh;
    width: 100%;
    padding: 10px;
    background-image: url("../assets/Babe.gif");
    background-size: cover;
    text-align: center;
    position: relative;
    .nav{
      position: absolute;
      top: 0;
      right: 0;  
      padding: 14px;
      color:white;
      font-size: 24px;
      input{
        width: 96px;
        font-size: 14px;
      }
      div{
        cursor: pointer;
        text-align: right;
      }
    }      
    .inner-width{ // for home-content
      max-width: 800px;
      margin: auto;    
      .title{
        padding: 12px 0;
      }
      .auth-status{
        margin-top: 60px;
      }  
      .div{
        padding: 60px 0 0 0; 
      }
    }
  }  
}


</style>
